/* eslint-disable no-shadow,consistent-return,no-param-reassign */

const state = {
  // Set default state(s) here
  info_screen: false,
  info_message: '',

  problem_screen: false,
  problem_message: '',
  problem_code: '',

  success_screen: false,
  success_message: '',

  loading_screen: false,
  loading_message: '',

  toast_screen: false,
  toast_data: null,

  is_screen: false,
};

const getters = {
  // Change value of state(s) with getter

};

const mutations = {
  toggleStateInfo(state, message) {
    state.info_screen = !state.info_screen;
    if (message) {
      state.info_message = message;
    }
  },
  toggleStateProblem(state, message) {
    state.problem_screen = !state.problem_screen;
    if (message) {
      if (message.error_code !== undefined) {
        state.problem_message = message.error_message;
        state.problem_code = message.error_code;
      } else {
        state.problem_message = message;
        state.problem_code = '';
      }
    }
  },
  toggleStateSuccess(state, message) {
    state.success_screen = !state.success_screen;
    if (message) {
      state.success_message = message;
    }
  },
  toggleStateLoading(state, message) {
    state.loading_screen = !state.loading_screen;
    if (message) {
      state.loading_message = message;
    }
  },
  showStateLoading(state, message) {
    state.loading_screen = true;
    if (message) {
      state.loading_message = message;
    }
  },
  hideStateLoading(state, message) {
    state.loading_screen = false;
    if (message) {
      state.loading_message = message;
    }
  },

  toggleToast(state, data) {
    state.toast_screen = !state.toast_screen;
    state.toast_data = data;
  },

  setScreen(state, data) {
    state.is_screen = data;
  },
};

const actions = {
  // toggleInfo({ commit }, message) {
  //   commit('toggleStateInfo', message);
  // },
  toggleInfo({ commit }, message) {
    const data = {
      type: 'info',
      title: 'Info',
      message,
    };
    commit('toggleToast', data);
  },
  // toggleProblem({ commit }, message) {
  //   commit('toggleStateProblem', message);
  // },
  toggleProblem({ commit }, message) {
    const data = {
      type: 'error',
      title: 'Error',
      message,
    };
    commit('toggleToast', data);
  },
  // toggleSuccess({ commit }, message) {
  //   commit('toggleStateSuccess', message);
  // },
  toggleWarning({ commit }, message) {
    const data = {
      type: 'warning',
      title: 'Warning',
      message,
    };
    commit('toggleToast', data);
  },
  toggleSuccess({ commit }, message) {
    const data = {
      type: 'success',
      title: 'Success',
      message,
    };
    commit('toggleToast', data);
  },
  toggleLoading({ commit }, message) {
    commit('toggleStateLoading', message);
  },
  hideLoading({ commit }, message) {
    commit('hideStateLoading', message);
  },
  showLoading({ commit }, message) {
    commit('showStateLoading', message);
  },
  screenProblem({ commit }, message) {
    commit('setScreen', true);
    commit('toggleStateProblem', message);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreNotificationScreen.js